// extracted by mini-css-extract-plugin
export default {"artCardDetailsContainer":"ArtCardDetails_artCardDetailsContainer__nzjs6"};